// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upLoadPicBox[data-v-ae88603a] {\n  position: relative;\n}\n.upLoadPicBox .nick[data-v-ae88603a] {\n  width: 100%;\n  position: absolute;\n  left: 70px;\n  top: 15px;\n}\n[data-v-ae88603a] .el-dialog__title {\n  font-weight: 600 !important;\n}\n[data-v-ae88603a] .el-dialog__body {\n  padding-top: 20px !important;\n}\n[data-v-ae88603a] .el-card__body {\n  padding: 0 0 20px !important;\n}", ""]);
// Exports
module.exports = exports;
